<template>
    <m-popper direction="bottom" :show="focus">
        <m-input :active="focus" @click="setFocus()" :line="showLine" :error="error" slot="target">
            <input class="text-black border w-full outline-none truncate p-2 cursor-pointer border-gray-400 rounded-md shadow-md"
                   placeholder="Select an option..." v-model="inputText" @focus="updateFocus(true)"
                   @blur="updateFocus(false)" ref="input" @keydown="keydown($event)" @input.self="inputChanged"
                   autocomplete="new-password"/>
            <div class="sprite-icons-select" slot="icon"></div>
        </m-input>
        <div class="shadow bg-white overflow-y-auto text-black" @mousedown.prevent=""
             style="min-width: 220px; max-height: 180px">
            <ul class="select text-left">
                <li class="p-2 text-sm text-center" v-if="filterOptions && filtered.length != list.length">Showing
                    {{ filtered.length }} of {{ list.length }}
                </li>
                <li class="p-2 block cursor-pointer hover_bg-gray-300" ref="items" v-for="(option, index) in filtered"
                    :value="option.value" @click.stop="clickOption(option)"
                    :class="{'bg-gray-300': selectedIndex == index}">{{ option.display }}
                </li>
            </ul>
        </div>
    </m-popper>
</template>
<script>
import {getWindowScroll, getAbsolute, getElementHeight} from '@/js/dom.js'

// option is object - convert to array with key and value properties
function mapToArray(options) {
    var ret = []
    for (var k in options) {
        ret.push({
            value: k,
            display: options[k]
        })
    }
    return ret
}

export default {
    props: {
        options: [Array, Object],
        value: [Object, Number, String],
        displayFunc: Function,
        valueFunc: Function,
        allowInput: {
            type: Boolean,
            default: false
        },
        filterOptions: {
            type: Boolean,
            default: false
        },
        showLine: {
            type: Boolean,
            default: true
        },
        error: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            focus: false,
            inputText: '',
            // current marked item set as key
            selectedIndex: -1
        }
    },
    watch: {
        options(val) {
            this.updateText()
        },
        value: {
            immediate: true,
            handler(val) {
                this.updateText()
            }
        },
    },
    computed: {
        filtered() {
            if (!this.filterOptions) {
                return this.list
            }
            return this.list.filter(f => f.display && f.display.toLowerCase().startsWith(this.inputText.toLowerCase()))
        },
        list() {
            if (!Array.isArray(this.options)) {
                // to array with {key, value}
                return mapToArray(this.options)
            }
            // once-off get all values and displays
            return this.options.map((option, index) => ({
                value: typeof (this.valueFunc) == 'function' ? this.valueFunc(option) : index,
                display: typeof (this.displayFunc) == 'function' ? this.displayFunc(option) : option.toString()
            }))
        }
    },
    methods: {
        scollIntoView() {
            if (this.selectedIndex != -1) {
                this.$refs.items[this.selectedIndex].scrollIntoView();
            }
        },
        inputChanged() {
            if (this.filterOptions) {
                // If filtering options always select the first one
                this.selectedIndex = 0
            } else {
                this.selectedIndex = this.list.findIndex(f => f.display.toLowerCase().startsWith(this.inputText.toLowerCase()))
                this.scollIntoView()
            }
        },
        updateText() {
            // Need to find display for the current value
            var index = this.list.findIndex(l => l.value == this.value)
            if (index == -1) {
                this.selectedIndex = -1
                this.inputText = ''
            } else {
                this.inputText = this.list[index].display
                this.selectedIndex = index
            }
        },
        keydown(event) {
            // enter
            if (event.keyCode == 13) {
                // If nothing selected than the first one
                if (this.selectedIndex == -1) {
                    this.selectedIndex = 0
                }
                var sel = this.$emit('input')
                this.$emit('input', sel.value)
                this.$emit('change', sel)
                this.updateFocus(false)
                return
            }
            // down
            if (event.keyCode == 40) {
                this.selectedIndex = (this.selectedIndex + 1) % this.filtered.length
                this.scollIntoView()
            }
            // up
            if (event.keyCode == 38) {
                this.selectedIndex--
                if (this.selectedIndex < 0) {
                    this.selectedIndex = this.filtered.length - 1
                }
                this.scollIntoView()
            }
            // tab
            if (event.keyCode != 9 && !this.allowInput) {
                event.preventDefault()
            }
            this.updateFocus(true)
        },
        updateFocus(focus) {
            if (focus != this.focus) {
                // Refresh input on new focus or blur
                this.updateText()
            }
            this.focus = focus
        },
        setFocus() {
            this.$refs.input.focus();
            this.$refs.input.select();
            this.updateFocus(true)
        },
        clickOption(item) {
            this.updateFocus(false)
            this.$emit('input', item.value)
            this.$emit('change', item)
        }
    }
}
</script>
